const BUSINESS_TIMEZONE =
  (typeof import.meta !== "undefined" &&
    import.meta.env?.VITE_BUSINESS_TIMEZONE?.trim()) ||
  "Europe/Madrid";

/**
 * Format a business calendar date in BUSINESS_TIMEZONE (default Europe/Madrid).
 * Does not use the browser's local timezone.
 */
export function formatBusinessDate(value, locale = "en-GB") {
  if (value == null || value === "") return "-";
  const date = value instanceof Date ? value : new Date(value);
  if (!Number.isFinite(date.getTime())) return "-";
  return new Intl.DateTimeFormat(locale, {
    timeZone: BUSINESS_TIMEZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
}

export { BUSINESS_TIMEZONE };
